const path = require('path');

const rootFolder = path.resolve('.');

const PATH_FOR_SEARCH = path.join(rootFolder, 'src');
const PATH_FOR_PUBLIC = path.join(rootFolder, 'public');
const I18NEXT_TRANSLATION_DIRECTORY = 'locales';
const I18NEXT_TRANSLATION_FILE_NAME = 'translation.json';

const SOURCE_LANGUAGE = 'ru';
const EXTENSIONS = ['json', 'ts'];

const POSTFIX = {
  DICTIONARIES: ['dictionary'],
  EXPLANATION: ['explanation'],
};

const SOURCE_DICTIONARY_KEY_FOR_WEBLATE_KEY = 'weblateKey';
const SOURCE_DICTIONARY_KEY_FOR_VALUE = 'value';
const SOURCE_DICTIONARY_KEY_FOR_EXPLANATION = 'explanation';

module.exports = {
  PATH_FOR_SEARCH,
  PATH_FOR_PUBLIC,
  I18NEXT_TRANSLATION_DIRECTORY,
  I18NEXT_TRANSLATION_FILE_NAME,
  SOURCE_LANGUAGE,
  EXTENSIONS,
  POSTFIX,
  SOURCE_DICTIONARY_KEY_FOR_WEBLATE_KEY,
  SOURCE_DICTIONARY_KEY_FOR_VALUE,
  SOURCE_DICTIONARY_KEY_FOR_EXPLANATION,
};
